/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */

import { PORTIONING } from "../../lib/data/portioning";
export function PortioningPage({ user, lang }) {
  const categories = [
    { key:"greens",   label:"🥬 Greens",    labelGr:"🥬 Σαλάτες" },
    { key:"grains",   label:"🌾 Grains",    labelGr:"🌾 Δημητριακά" },
    { key:"proteins", label:"🍗 Proteins",  labelGr:"🍗 Πρωτεΐνες" },
    { key:"spreads",  label:"🫙 Spreads",   labelGr:"🫙 Spreads" },
    { key:"dressings",label:"🥣 Dressings", labelGr:"🥣 Dressings" },
    { key:"toppings", label:"🧆 Toppings",  labelGr:"🧆 Toppings" },
  ];

  return (
    <div className="anim-fade">
      <div style={{ marginBottom:18 }}>
        <div style={{ fontWeight:800, fontSize:18, color:"var(--text-primary)" }}>
          ⚖️ {lang==="gr" ? "Οδηγός Portioning" : "Portioning Reference"}
        </div>
        <div style={{ fontSize:13, color:"var(--text-muted)", marginTop:4 }}>
          {lang==="gr"
            ? "Επίσημα γραμμάρια ανά συστατικό — για εκπαίδευση, food costing & audits. Στο live service ακολουθούμε πάντα τους οπτικούς κανόνες."
            : "Official grams per ingredient — for training, food costing & audits. In live service, always follow visual portioning rules."}
        </div>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))", gap:14 }}>
        {categories.map(cat => (
          <div key={cat.key} style={{ background:"var(--surface)", border:"1.5px solid var(--border)", borderRadius:18, overflow:"hidden" }}>
            <div style={{ background:"var(--green)", padding:"12px 16px", fontWeight:800, fontSize:14, color:"#fff" }}>
              {lang==="gr" ? cat.labelGr : cat.label}
            </div>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <tbody>
                {PORTIONING[cat.key].map(([name, grams], i) => (
                  <tr key={name} style={{ borderBottom: i < PORTIONING[cat.key].length-1 ? "1px solid var(--border)" : "none" }}>
                    <td style={{ padding:"10px 16px", fontSize:13, fontWeight:600, color:"var(--text-primary)" }}>{name}</td>
                    <td style={{ padding:"10px 16px", textAlign:"right" }}>
                      <span style={{ fontFamily:"Bebas Neue,sans-serif", fontSize:18, color:"var(--green)", letterSpacing:1 }}>{grams}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>

      {/* Visual rules reminder */}
      <div style={{ marginTop:20, background:"#FFFBEB", border:"1.5px solid #FCD34D", borderRadius:16, padding:"14px 18px" }}>
        <div style={{ fontWeight:800, fontSize:13, color:"#B45309", marginBottom:8 }}>
          ⚠️ {lang==="gr" ? "Σημαντικό" : "Important"}
        </div>
        <div style={{ fontSize:13, color:"#92400E", lineHeight:1.7 }}>
          {lang==="gr"
            ? "Οι ποσότητες αυτές χρησιμοποιούνται ΜΟΝΟ για εκπαίδευση, food costing και audits. Κατά τη λειτουργία του καταστήματος, ακολουθούνται πάντα οι οπτικοί κανόνες portioning (κουτάλες, scoops, scoop rules) που περιγράφονται στο SOP."
            : "These quantities are used ONLY for training, food costing and audits. During live service, always follow the visual portioning rules (ladles, scoops, scoop rules) described in the SOP."}
        </div>
      </div>
    </div>
  );
}

